import React from 'react'
import './Help.css'
import { icon } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faHeadset, faLocationDot } from '@fortawesome/free-solid-svg-icons'


const Help = () => {

    const helpData = [
        {
            text: "How Will I Know If Order Is Placed Successfully?",
            icon: faEnvelope
        },
        {
            text: "Akshya Nagar 1St Block 1St Cross, Rammurthy Nagar, Bangalore-560016",
            icon: faLocationDot
        },
        {
            text: "0000000000",
            icon: faHeadset
        },

    ]

    return (
        <section className='Help'>
            <div className='container'>
                <div className='help_main_card'>
                    <div className='row align-items-center'>
                        <div className='col-md-6 order-md-1 order-sm-2 order-2'>
                            <div className='left_side_part'>

                                {helpData?.map((item) => {
                                    return (
                                        <div className='help_content'>
                                            <div className='icon_holder'>
                                                <FontAwesomeIcon icon={item?.icon} className='icon'/>
                                            </div>
                                            <div className='text_holder'>
                                                <p className='text'>{item?.text}</p>
                                            </div>
                                        </div>
                                    )
                                })}


                            </div>
                        </div>

                        <div className='col-md-6 order-md-2 order-sm-1 order-1'>
                            <div className='right_side_part'>
                                <div className='img_holder'>
                                    <img src="/assets/Images/FAQ/Help/help.png" className='helpimg'/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Help
